import { processClasses, setSchedule } from "./database";

function setLocalSchedule(schedule) {
    var classes = JSON.parse(schedule)
    classes = classes.filter((c) => !c[0].includes("Independent Study") && !c[0].includes("Morning Ex"))
    //console.log(classes)
    var parsedNames = classes.map((c) => {
        if (!c[0].includes("Independent Study")) {
            c[0] = c[0].replace("PE-C", "Sci C")
            console.log(c)
        return [c[0].split("-").slice(0, -1).join("-"), c[0].split("-").at(-1).split("(")[0].replace(/ /g, ""), c[0].split("-").at(-1).split("(")[1].replace(")", "").replace(/ /g, "")]}})
    console.log(parsedNames.length, JSON.parse(schedule).length);
    var userClasses = processClasses(classes, parsedNames, true);
    var user = {classes: userClasses}

    window.localStorage.setItem('schedule', JSON.stringify(user));
}

function getLocalSchedule() {
    return JSON.parse(window.localStorage.getItem('schedule'));
}

function saveLocalSettings(settings) {
    var schedule = getLocalSchedule()
    delete settings.local;
    var flexes = settings.flex;
    delete settings.flex;
    Object.entries(flexes).forEach((f) => {
        if (f[1]) {
            schedule.classes[f[0]].params.flex = true;
        } else {
            delete schedule.classes[f[0]].params.flex;
        }
    })
    schedule.settings = settings;
    window.localStorage.setItem('schedule', JSON.stringify(schedule));
}

function saveLocalGCConfig(refresh_token) {
    var schedule = getLocalSchedule();
    if (schedule.settings === undefined) {
        schedule.settings = {};
    }
    schedule.settings.gcconfig = {refresh_token:refresh_token};
    localStorage.setItem('schedule', JSON.stringify(schedule));
}

function convertToOnlineSchedule(auth_user) {
    return new Promise((resolve, reject) => {
    var schedule = getLocalSchedule();
    var data = []
    Object.entries(schedule.classes).forEach((c) => {
        data.push([c[1].id, c[1].params.tname, c[1].params.rnumber]);
        delete c[1].params.tname;
        delete c[1].params.rnumber;
        schedule.classes[c[0]] = c[1];
    })

    if (schedule.settings === undefined) {
        schedule.settings = {};
    }
    
   
    var onlineSchedule = {classes: schedule.classes, settings: schedule.settings, info:{
        name: auth_user.displayName,
        email: auth_user.email,
        photo: auth_user.photoURL,
    }
    };
    setSchedule(auth_user, onlineSchedule, data).then(() => {
        deleteLocalSchedule();
        resolve();
    })
})
   // return onlineSchedule;
}

function deleteLocalSchedule() {
    window.localStorage.removeItem('schedule');
}

function watchedTutorialLocal() {
    var schedule = getLocalSchedule();
    if (schedule.settings === undefined) {
        schedule.settings = {tname:true, rnumber:true, period:false, pe:false, wschedule:false, coverride:false, homework:""};
    }
    schedule.settings.tutorial = true;
    window.localStorage.setItem('schedule', JSON.stringify(schedule));
}

export { setLocalSchedule, getLocalSchedule, saveLocalGCConfig, saveLocalSettings, convertToOnlineSchedule, watchedTutorialLocal }